var styles = {
  "ShadowBevel": "Polaris-ShadowBevel"
};

export { styles as default };
